module.exports = __webpack_public_path__ + "img/GDQ-svarsstapel_10.ba717c31.gif";